<div class="" [formGroup]="form">
  <div class="d-flex align-items-center gap-2">
    <ng-container i18n>Set expiration</ng-container>
    <mat-form-field2 [showLabel]="false" [hidePlaceholder]="true">
      <mat-select placeholder="Days" i18n-placeholder formControlName="expired_days">
        <mat-option *ngFor="let day of availableExpiredDays" [value]="day.value">{{ day.label }}</mat-option>
      </mat-select>
      <span matSuffix i18n>Day(s)</span>
    </mat-form-field2>
    <ng-container i18n>after template is sent</ng-container>
  </div>
</div>
<hr />
<div class="" [formGroup]="form">
  <div class="row">
    <div class="col-md-6">
      <div class="row">
        <div class="col-12">
          <mat-form-field2 class="mat-block">
            <input
              matInput
              type="text"
              formControlName="name"
              i18n-placeholder
              placeholder="Template Name"
              i18n-matTooltip
              matTooltip="Enter a name for this template. Choose a name that will allow you to quickly identify this specific template among your list of templates. The signer(s) will see this name."
              [required]="true"
            />
          </mat-form-field2>
        </div>

        <div class="col-12">
          <mat-form-field2 class="mat-block">
            <textarea
              matInput
              cdkTextareaAutosize
              cdkAutosizeMaxRows="5"
              cdkAutosizeMinRows="3"
              formControlName="description"
              i18n-matTooltip
              matTooltip="Enter a description for this template. This will allow you to provide a more detailed explanation of the contents and purpose of the template. The signer will not see this description."
              i18n-placeholder
              placeholder="Description"
            ></textarea>
          </mat-form-field2>
        </div>

        <div class="col-12">
          <app-form-tags2
            i18n-label
            label="Select or Create Tag(s)"
            i18n-matTooltip
            matTooltip="Select an existing tag, or create a new tag to assign to this template. Tags allow you to quickly filter templates that have certain attributes."
            formControlName="tags"
            [items]="tags$ | async"
          ></app-form-tags2>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="row">
        <div class="col-12">
          <mat-form-field2 class="mat-block">
            <input
              matInput
              type="text"
              formControlName="title"
              i18n-matTooltip
              matTooltip="Enter a custom email subject for the email that will be used to send this template."
              i18n-placeholder
              placeholder="Email Subject"
            />
          </mat-form-field2>
        </div>

        <div class="col-12">
          <mat-form-field2 class="mat-block">
            <textarea
              matInput
              cdkTextareaAutosize
              cdkAutosizeMaxRows="5"
              cdkAutosizeMinRows="3"
              formControlName="message"
              i18n-matTooltip
              matTooltip="Enter a custom email message for the email that will be used to send this template."
              i18n-placeholder
              placeholder="Email Message"
            ></textarea>
          </mat-form-field2>
        </div>

        <!--          <div class="col-12">-->
        <!--            <mat-form-field2 class="mat-block">-->
        <!--              <app-select-->
        <!--                label="Select Groups"-->
        <!--                matTooltip="Select a group to assign to this template. Groups allow you to organize your templates into collections."-->
        <!--                [items]="groups$ | async"-->
        <!--                bindLabel="name"-->
        <!--                bindValue="group_id"-->
        <!--                formControlName="groups"-->
        <!--              >-->
        <!--              </app-select>-->
        <!--            </mat-form-field2>-->
        <!--          </div>-->
      </div>
    </div>
  </div>
</div>
